// extracted by mini-css-extract-plugin
export default {"loginCard":"Login_loginCard__gxdw5"};